import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "id"];
import * as React from 'react';
import { useId } from '@base-ui/utils/useId';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { CalendarGridRootContext } from "./CalendarGridRootContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export const CalendarGridRoot = /*#__PURE__*/React.forwardRef(function CalendarGridRoot(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      id: idProp
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const id = useId(idProp);
  const props = {
    role: 'grid',
    id
  };
  const contextValue = React.useMemo(() => ({
    id
  }), [id]);
  const element = useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [props, elementProps]
  });
  return /*#__PURE__*/_jsx(CalendarGridRootContext.Provider, {
    value: contextValue,
    children: element
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridRoot.displayName = "CalendarGridRoot";